import { createContext, type ComponentChildren } from 'preact';
import { useContext } from 'preact/hooks';
import type { Market } from '@/domain/Market';

const MarketProviderContext = createContext<Market | undefined>(undefined);

export type MarketProviderProps = Market & {
  children: ComponentChildren;
};

/**
 * Exposes information about the current market, such as the currency and locale
 */
export function MarketProvider({ children, ...props }: MarketProviderProps) {
  return (
    <MarketProviderContext.Provider value={props}>
      {children}
    </MarketProviderContext.Provider>
  );
}

export default function useMarketConfig(): Market {
  const context = useContext(MarketProviderContext);

  if (!context) {
    throw new Error('useMarketConfig must be used within MarketProvider');
  }
  return context;
}
